import React from 'react';
export interface IconProps {
  width?: number;
  height?: number;
}
const WsRevenueCalculator = ({ width = 42, height = 42 }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="21" cy="21" r="21" fill="#BDBDBD" />
    <path
      d="M27.9998 9.3335H13.9998C12.7112 9.3335 11.6665 10.3782 11.6665 11.6668V30.3335C11.6665 31.6222 12.7112 32.6668 13.9998 32.6668H27.9998C29.2885 32.6668 30.3332 31.6222 30.3332 30.3335V11.6668C30.3332 10.3782 29.2885 9.3335 27.9998 9.3335Z"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3335 14H25.6668"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.6665 23.3335V28.0002"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.6665 18.6665H25.6773"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 18.6665H21.0108"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3335 18.6665H16.3443"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 23.3335H21.0108"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3335 23.3335H16.3443"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 28H21.0108"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3335 28H16.3443"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default WsRevenueCalculator;
